import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const PORTAL_ID = 'van-admin-modal-portal';
const BODY_CLASS = 'van-admin-modal-open';

function getPortalNode() {
	if (typeof document === 'undefined') return null;
	let node = document.getElementById(PORTAL_ID);
	if (!node) {
		node = document.createElement('div');
		node.id = PORTAL_ID;
		document.body.appendChild(node);
	}
	return node;
}

/**
 * Portal modal — backdrop + dialog as siblings on document.body so nothing in admin layout blocks clicks.
 */
export default function AdminModal({ open, onClose, children, className = '', ariaLabelledBy }) {
	useEffect(() => {
		if (!open) return undefined;
		document.body.classList.add(BODY_CLASS);
		const prev = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
		return () => {
			document.body.classList.remove(BODY_CLASS);
			document.body.style.overflow = prev;
		};
	}, [open]);

	if (!open || typeof document === 'undefined') return null;

	const portalNode = getPortalNode();
	if (!portalNode) return null;

	return ReactDOM.createPortal(
		<>
			<div
				className="admin-cms-modal-backdrop"
				role="presentation"
				aria-hidden="true"
				onClick={onClose}
			/>
			<div
				className={`admin-cms-modal ${className}`.trim()}
				role="dialog"
				aria-modal="true"
				aria-labelledby={ariaLabelledBy}
				onClick={(e) => e.stopPropagation()}
			>
				{children}
			</div>
		</>,
		portalNode
	);
}
